import {
  GLOBAL_POLICY_SLUG,
  GLOBAL_SECRETS_POLICY_SLUG,
} from "@shared/constants";
import { PolicyProduct } from "@shared/types";

export const productToSlug = (product: PolicyProduct): string => {
  switch (product) {
    case "sast":
      return GLOBAL_POLICY_SLUG;
    case "secrets":
      return GLOBAL_SECRETS_POLICY_SLUG;
  }
};

export const productToUrl = (product: PolicyProduct): string => {
  switch (product) {
    case "sast":
      return "policies";
    case "secrets":
      return "policies/secrets";
  }
};
